// @flow

import React, { Component } from 'react';
import styler from 'react-styling';
import moment from 'moment';
import $ from 'jquery';
import 'fullcalendar';
import 'fullcalendar/dist/fullcalendar.min.css';

const style = styler `
  Container
    background-color: #182B56
    position: fixed
    overflow-y: scroll
    height: 100%
    color: #F5F5F5
  CalendarHeader
    padding: 5px 0 20px 25px
  Date
    font-size: 16px
  Time
    font-size: 60px
    font-weight: 200
    margin-bottom: -5px
`;

const eventTimeFormat = 'H:mm';

class MeetingroomScheduler extends Component {

  componentDidMount() {
    const { lang, events, clock } = this.props;
    const schedulerEvents = this._getSchedulerEvents(events);
    const locale = lang.locale;
    const interval = this._calculateCalendarInterval(clock, events);
    this.fullcalendar().fullCalendar({
      allDaySlot: false,
      header: false,
      slotDuration: '01:00:00',
      locale,
      slotLabelFormat: 'HH:mm',
      timeFormat: eventTimeFormat,
      timezone: 'local',
      defaultView: 'agenda',
      events: schedulerEvents,
      minTime: interval.minTime,
      maxTime: interval.maxTime,
      displayEventTime: true,
      viewRender: (view, element) => {
        element.find('.fc-head').html('');
      },
      // required, otherwise fullcalendar won't show endDate for events with duration < 1 hour.
      eventAfterRender: (event, el) => {
        // if event has fc-short class, data-start value will be displayed
        // remove fc-short class and update fc-time span text
        if (el.is('.fc-short')) {
          const formattedTime = $.fullCalendar.formatRange(event.start, event.end, eventTimeFormat);
          el.find('.fc-time span').text(`${formattedTime} - ${event.title}`);
          el.removeClass('fc-short');
          el.find('.fc-title').remove();
        }
      },
    });
  }

  componentWillReceiveProps(nextProp: Object) {
    const interval = this._calculateCalendarInterval(nextProp.clock, nextProp.events);
    this.fullcalendar().fullCalendar('option', 'minTime', interval.minTime);
    this.fullcalendar().fullCalendar('option', 'maxTime', interval.maxTime);
    this.fullcalendar().fullCalendar('removeEvents');
    this.fullcalendar().fullCalendar('renderEvents', this._getSchedulerEvents(nextProp.events));
  }

  componentWillUnmount() {
    this.fullcalendar().fullCalendar('destroy');
  }

  _getSchedulerEvents = (events: Array<Object>) => {
    const schedulerEvents = [];
    events.forEach(e => {
      const schedulerEvent = e;
      schedulerEvent.title = e.organizer.displayName;
      schedulerEvents.push(schedulerEvent);
    });
    return schedulerEvents;
  }

  calendar: Object;

  fullcalendar = () => {
    const calendar = this.calendar;
    return $(calendar);
  }

  _calculateCalendarInterval = (clock: Object, events: Array<Object>) => {
    let min = moment(clock);
    if (events.length) {
      // need to adjust startTime for events e such as e.start < now < e.end
      const nextEvent = events[0];
      if (nextEvent.start.isBefore(min)) {
        min = moment(nextEvent.start);
      }
    }

    const minTime = `${min.format('HH')}:00:00`;
    const maxDate = min.clone().add(1, 'days');
    const maxTime = `1.${maxDate.format('HH')}:00:00`;
    return {
      minTime,
      maxTime,
    };
  }

  props: {
    meetingroom: Object,
    events: Array<Object>,
    clock: Object,
    lang: Object,
  };

  render() {
    const { clock } = this.props;
    return (
      <div style={style.Container} className="room-scheduler">
        <div style={style.CalendarHeader}>
          <div style={style.Time}>
            { clock.format('H:mm') }
          </div>
          <div style={style.Date}>
            { clock.format('dddd D. MMMM') }
          </div>
        </div>
        <div ref={(c) => { this.calendar = c; }}>{''}</div>
      </div>
    );
  }

}

export default MeetingroomScheduler;



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingroomScheduler.js